export enum StripeErrorCode {
  PAYS_001 = 'PAYS_001', // resource missing
  PAYS_002 = 'PAYS_002', // api key expired
  PAYS_003 = 'PAYS_003', // stripe specific error
  PAYS_004 = 'PAYS_004', // card decline, currency not supported
  PAYS_005 = 'PAYS_005', // lambda internal services error
  PAYS_006 = 'PAYS_006', // 3ds check failure
  DEFAULT = 'DEFAULT',
}
